import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import apiClientPlatform from '@/apiClientPlatform'
import type {
  PlatformTrialWinbackListResponse,
  PlatformTrialWinbackSendAllResponse,
  PlatformTrialWinbackSendResponse,
} from '@/types/platform'

export const platformTrialWinbackKey = ['platformTrialWinback'] as const

export const useTrialWinbackListQuery = () => {
  return useQuery({
    queryKey: platformTrialWinbackKey,
    queryFn: async () => {
      const { data } =
        await apiClientPlatform.get<PlatformTrialWinbackListResponse>(
          '/platform/campaigns/trial-winback'
        )
      return data
    },
  })
}

export const useSendTrialWinbackMutation = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (ownerId: string) => {
      const { data } =
        await apiClientPlatform.post<PlatformTrialWinbackSendResponse>(
          `/platform/campaigns/trial-winback/${ownerId}/send`
        )
      return data
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: platformTrialWinbackKey })
      await qc.invalidateQueries({ queryKey: ['platformAudit'] })
    },
  })
}

export const useSendTrialWinbackAllMutation = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const { data } =
        await apiClientPlatform.post<PlatformTrialWinbackSendAllResponse>(
          '/platform/campaigns/trial-winback/send-all'
        )
      return data
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: platformTrialWinbackKey })
      await qc.invalidateQueries({ queryKey: ['platformAudit'] })
    },
  })
}
